import React, { memo, useMemo } from 'react';
import BaseModal from '../../../components/modals/BaseModal/BaseModal';
import './GuaranteeSlotsModal.scss';

const GuaranteeSlotsModal = ({
	slots = [],
	onSaveChanges = () => {},
	onCancel = () => {},
	resourceType,
	dateAndTime
}) => {
	const currentSlots = useMemo(() => {
		return slots.filter((s) => !s.is_flex);
	}, [slots]);

	const isGuaranteed = currentSlots.every((slot) => slot.is_guaranteed);
	const isMultipleSlots = currentSlots.length > 1;
	const shiftText = isMultipleSlots ? 'shifts' : 'shift';
	const shouldToAddOnDemandText = slots.length > currentSlots.length;
	const onDemandText = shouldToAddOnDemandText ? 'open, on-demand ' : 'open ';
	const guaranteeText = isGuaranteed
		? `remove the guarantee from  ${isMultipleSlots ? 'all ' : 'this '}${onDemandText}`
		: `guarantee ${isMultipleSlots ? '' : `this ${onDemandText}`} `;
	const unclaimedText = isGuaranteed ? 'guarantee ' : `all ${onDemandText}`;

	const title = !isGuaranteed
		? `Guarantee ${isMultipleSlots ? 'all' : 'this'} open ${shouldToAddOnDemandText ? 'On-Demand ' : ''}${shiftText}`
		: `Remove guarantee from ${isMultipleSlots ? 'all' : 'this'}  open ${
				shouldToAddOnDemandText ? 'on-demand ' : ''
		  } ${shiftText}`;

	const guaranteeDetails = !isGuaranteed ? (
		<div className="guarantee-section">
			<p className="guarantee-bold">
				Guaranteed Shifts&trade; are picked up with 20% higher claim rate & have higher show rates.
			</p>
			<p className="guarantee-italic">
				If this shift is claimed, you are committing to pay for the caregiver, even if you choose to cancel them later.
			</p>
		</div>
	) : (
		<div className="guarantee-section">
			<p className="guarantee-bold">
				Guaranteed Shifts&trade; are picked up more often than non-Guaranteed Shifts. Your fulfillment rate may decrease
				significantly.
			</p>
			<p className="guarantee-italic">
				This change will apply only to unclaimed shifts that were previously Guaranteed. If your Guaranteed Shift&trade;
				has already been claimed, you are still required to pay.
			</p>
		</div>
	);

	return (
		<BaseModal
			key="guarantee-slots-modal"
			title={title}
			className="guarantee-slots-modal"
			primaryActionLabel="Confirm"
			onPrimaryAction={() => onSaveChanges(currentSlots, !isGuaranteed)}
			secondaryActionLabel="Cancel"
			onSecondaryAction={onCancel}
			onHide={onCancel}
		>
			<p>
				Are you sure you want to {guaranteeText}
				<b>
					{!isMultipleSlots ? '' : unclaimedText}
					{resourceType} {shiftText} on {dateAndTime}
				</b>
				?
			</p>
			{guaranteeDetails}
		</BaseModal>
	);
};

export default memo(GuaranteeSlotsModal);
